import { Customer } from '../types';
import { CustomerToken } from '../../types/customers';

export enum ActionTypes {
    GetCustomer = '[customer] GET_CUSTOMER',
    CustomerResponse = '[customer] FETCH_CUSTOMER_RESPONSE',
    CustomerNotFoundResponse = '[customer] CUSTOMER_NOT_FOUND',
    EditCustomerField = '[customer] EDIT_CUSTOMER_FIELD',
    FetchEditCustomerFieldResponse = '[customer] FETCH_EDIT_CUSTOMER_FIELD_RESPONSE',
    GetCustomerTokens = '[customer] GET_CUSTOMER_TOKENS',
    CustomerTokensResponse = '[customer] FETCH_CUSTOMER_TOKENS_RESPONSE',
    OpenDeleteCustomerModal = '[customer] OPEN_DELETE_CUSTOMER_MODAL',
    CloseDeleteCustomerModal = '[customer] CLOSE_DELETE_CUSTOMER_MODAL',
    FetchDeleteCustomer = '[customer] FETCH_DELETE_CUSTOMER',
    FetchDeleteCustomerResponse = '[customer] FETCH_DELETE_CUSTOMER_RESPONSE',
    ChangeCustomerId = '[customer] CHANGE_CUSTOMER_ID',
    ChangeCustomerIdError = '[customer] CHANGE_CUSTOMER_ID_ERROR',
    ToggleChangeCustomerIdModal = '[customer] TOGGLE_CHANGE_CUSTOMER_ID_MODAL',
}

export interface GetCustomer {
    type: ActionTypes.GetCustomer;
    payload: {
        accountId: string;
        id: string;
    };
}

export interface CustomerResponse {
    type: ActionTypes.CustomerResponse;
    payload: {
        customer: Customer;
    };
    meta: {
        cause: GetCustomer;
    };
}

export interface GetCustomerTokens {
    type: ActionTypes.GetCustomerTokens;
    payload: {
        accountId: string;
        id: string;
    };
}

export interface CustomerTokensResponse {
    type: ActionTypes.CustomerTokensResponse;
    payload: {
        tokens: CustomerToken[];
    };
    meta: {
        cause: GetCustomerTokens;
    };
}

export interface CustomerNotFoundResponse {
    type: ActionTypes.CustomerNotFoundResponse;
    meta: {
        cause: GetCustomer;
    };
}

export interface FieldValue {
    [id: string]: string | boolean | null | undefined;
}

export interface EditCustomerField {
    type: ActionTypes.EditCustomerField;
    payload: {
        accountId: string;
        id: string;
        name: string;
        value: FieldValue;
    };
}

export interface FetchEditCustomerFieldResponse {
    type: ActionTypes.FetchEditCustomerFieldResponse;
    payload: {
        customer: Customer;
    };
    meta: {
        cause: EditCustomerField;
    };
}

export function getCustomer(accountId: string, id: string): GetCustomer {
    return {
        type: ActionTypes.GetCustomer,
        payload: {
            id,
            accountId,
        },
    };
}

export function getCustomerTokens(accountId: string, id: string): GetCustomerTokens {
    return {
        type: ActionTypes.GetCustomerTokens,
        payload: {
            id,
            accountId,
        },
    };
}

export function editCustomerField(accountId: string, id: string, name: string, value: FieldValue): EditCustomerField {
    return {
        type: ActionTypes.EditCustomerField,
        payload: {
            accountId,
            id,
            value,
            name,
        },
    };
}

export interface OpenDeleteCustomerModal {
    type: ActionTypes.OpenDeleteCustomerModal;
    payload: {
        accountId: string;
        customerId: string;
    };
}

export function openDeleteCustomerModal(accountId: string, customerId: string): OpenDeleteCustomerModal {
    return {
        type: ActionTypes.OpenDeleteCustomerModal,
        payload: {
            accountId,
            customerId,
        },
    };
}

export interface CloseDeleteCustomerModal {
    type: ActionTypes.CloseDeleteCustomerModal;
    payload: {};
}

export function closeDeleteCustomerModal(): CloseDeleteCustomerModal {
    return {
        type: ActionTypes.CloseDeleteCustomerModal,
        payload: {},
    };
}

export interface FetchDeleteCustomer {
    type: ActionTypes.FetchDeleteCustomer;
    payload: {
        accountId: string;
        customerId: string;
    };
}

export function deleteCustomer(accountId: string, customerId: string): FetchDeleteCustomer {
    return {
        type: ActionTypes.FetchDeleteCustomer,
        payload: {
            accountId,
            customerId,
        },
    };
}

export interface ChangeCustomerId {
    type: ActionTypes.ChangeCustomerId;
    payload: {
        accountId: string;
        oldCustomerId: string;
        newCustomerId: string;
    };
}

export function changeCustomerId(accountId: string, oldCustomerId: string, newCustomerId: string): ChangeCustomerId {
    return {
        type: ActionTypes.ChangeCustomerId,
        payload: {
            accountId,
            oldCustomerId,
            newCustomerId,
        },
    };
}

export interface FetchDeleteCustomerResponse {
    type: ActionTypes.FetchDeleteCustomerResponse;
    payload: {};
}

export interface ToggleChangeCustomerIdModal {
    type: ActionTypes.ToggleChangeCustomerIdModal;
    payload: {
        open: boolean;
    };
}

export function openChangeCustomerIdModal(): ToggleChangeCustomerIdModal {
    return {
        type: ActionTypes.ToggleChangeCustomerIdModal,
        payload: {
            open: true,
        },
    };
}
export function closeChangeCustomerIdModal(): ToggleChangeCustomerIdModal {
    return {
        type: ActionTypes.ToggleChangeCustomerIdModal,
        payload: {
            open: false,
        },
    };
}
export interface ChangeCustomerIdError {
    type: ActionTypes.ChangeCustomerIdError;
    payload: {
        newCustomerId: string;
    };
}

export type Actions =
    | GetCustomer
    | CustomerResponse
    | CustomerNotFoundResponse
    | GetCustomerTokens
    | CustomerTokensResponse
    | EditCustomerField
    | FetchEditCustomerFieldResponse
    | OpenDeleteCustomerModal
    | CloseDeleteCustomerModal
    | FetchDeleteCustomer
    | FetchDeleteCustomerResponse
    | ChangeCustomerId
    | ToggleChangeCustomerIdModal
    | ChangeCustomerIdError;
